'use client'

import Heading from '@shared/components/Heading/Heading'
import { type IPaths } from '@shared/lib/paths'
import { iconMappings } from '@/lib/iconMappings'
import { Box, Grid, Row, Stack } from '@christiankaindl/lyts'
import Link from 'next/link'
// import Text from '@shared/components/Text/Text'
import { card } from '@/styles/theme.css'
import { useState } from 'react'
import Button from '@shared/components/Button/Button'

export default function Categories({
  id,
  paths,
}: {
  paths: IPaths
  id: string
}) {
  const [items] = useState(() =>
    Object.entries(paths).filter(([, { hidden }]) => !hidden),
  )
  const [open, setOpen] = useState(items.length < 12)

  return (
    <>
      <Grid
        gap={1.5}
        gridMaxRowItems={1}
        style={{
          gridTemplateColumns:
            'repeat(auto-fill,minmax(min(var(--_1yo99wa0),100%),1fr))',
          maskImage: !open
            ? 'linear-gradient(to top, transparent 10%, black 40%)'
            : undefined,
          padding: 21, // With the linear gradient, the shadows are cut off (as if overflow: hidden would be set), so account for that
          margin: -21,
        }}
      >
        {items.map(([key, { name }], index) => {
          const Icon = iconMappings[key] ?? iconMappings.institution
          return (
            <Stack asChild key={key} gap={0.5}>
              <Link
                href={`/${id}/${key}`}
                className={card}
                style={{
                  padding: 21,
                  borderRadius: 12,
                  display: open || index < 12 ? undefined : 'none',
                }}
              >
                <Row>
                  {Icon && <Icon color='#A48757' size={20} width={20} />}
                  <Heading
                    h={4}
                    maxLines={1}
                    style={{ fontFamily: 'var(--noto-font)' }}
                  >
                    {name}
                  </Heading>
                </Row>
                {/* <Text color='secondary'>
                    {description}
                  </Text> */}
              </Link>
            </Stack>
          )
        })}
      </Grid>
      {items.length > 12 && <ExpandArea open={open} setOpen={setOpen} />}
      <hr />
    </>
  )
}

function ExpandArea({
  open,
  setOpen,
}: {
  open: boolean
  setOpen: (open: boolean) => void
}) {
  return (
    <Box xAlign='center'>
      <Button
        size='large'
        circular
        onClick={() => {
          setOpen(!open)
        }}
        style={{ marginTop: !open ? -24 : undefined }}
      >
        {open ? 'Weniger' : 'Mehr'} anzeigen
      </Button>
    </Box>
  )
}
